import { APIRequestUpadload } from "./APIRequest";

export function numberOnly(string){
  return string.replace(/[^0-9]/g, '');
}

export function onlyEnglish(string){
  return string.replace(/[^a-zA-Z0-9]/g, '');
}

export async function uploadFunction(file){
  let resData;
  const formData = new FormData();
  formData.append('file', file);
  await APIRequestUpadload({
    method: 'POST',
    url: '/external/upload/upload-img',
    data: formData,
    auth: true
  }).then(response => {
    if (response && response.code === 0){
      resData = response.url;
    }
  }).catch(error => {
    console.log(error);
    return error;
  });

  return resData;
}